module.exports = __webpack_public_path__ + "img/pricing_popup_before_payment.732eb74e.png";